import { render, staticRenderFns } from "./ViewGroup.vue?vue&type=template&id=c26bd3ae&"
import script from "./ViewGroup.vue?vue&type=script&lang=js&"
export * from "./ViewGroup.vue?vue&type=script&lang=js&"
import style0 from "./ViewGroup.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ViewGroup.vue"
export default component.exports